import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  public searchString = new BehaviorSubject(null);
  public headerSubscription = new BehaviorSubject(null);

  constructor() {}

  setHeaderOptions(value)
  {
    this.headerSubscription.next(value);
  }

  getHeaderOptions()
  {
    return this.headerSubscription.asObservable();
  }

}

